module.exports = __webpack_public_path__ + "img/empty_nothing_img.820296f4.svg";